/* GOWin® Store — carrito v4: cantidad inline estilo The Feed + cantidades manuales agrupadas */
(() => {
  if (window.GowinCartFeedStyleV4) return;
  window.GowinCartFeedStyleV4 = true;

  const DIRECT_QTY_MAX = 10;
  const CUSTOM_VALUE = '__gowin_custom_qty__';
  let observer;
  let observedDrawer;
  let scheduled = false;
  let wasOpen = false;

  const getCurrentQty = (input) => Math.max(1, parseInt(input?.value || '1', 10) || 1);

  const getExplicitMax = (input) => {
    const max = parseInt(input?.getAttribute('max') || '', 10);
    return Number.isFinite(max) && max > 0 ? max : null;
  };

  const updateRealQuantity = (input, nextQty) => {
    if (!input || !Number.isFinite(nextQty)) return;
    if (String(input.value) === String(nextQty)) return;
    input.value = String(nextQty);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const populateSelect = (select, input) => {
    const currentQty = getCurrentQty(input);
    const explicitMax = getExplicitMax(input);
    const directMax = Math.min(DIRECT_QTY_MAX, explicitMax || DIRECT_QTY_MAX);
    const allowCustom = explicitMax === null || explicitMax > DIRECT_QTY_MAX || currentQty > DIRECT_QTY_MAX;
    const signature = `${currentQty}:${explicitMax || 'none'}:${input.disabled ? 1 : 0}`;

    if (select.dataset.gowinQtySignature === signature) {
      const expected = String(currentQty);
      if (select.value !== expected) select.value = expected;
      select.disabled = !!input.disabled;
      return;
    }

    const fragment = document.createDocumentFragment();

    const remove = document.createElement('option');
    remove.value = '0';
    remove.textContent = '0 (eliminar)';
    fragment.appendChild(remove);

    for (let qty = 1; qty <= directMax; qty += 1) {
      const option = document.createElement('option');
      option.value = String(qty);
      option.textContent = String(qty);
      option.selected = qty === currentQty;
      fragment.appendChild(option);
    }

    if (allowCustom) {
      const custom = document.createElement('option');
      custom.value = CUSTOM_VALUE;
      custom.textContent = '11+ (ingresar cantidad)';
      fragment.appendChild(custom);
    }

    /* En iOS, un optgroup crea la separación visual tipo “Previous Inputs” de The Feed.
       La cantidad manual actual queda debajo de 11+, no mezclada con 1–10. */
    if (currentQty > DIRECT_QTY_MAX) {
      const previous = document.createElement('optgroup');
      previous.label = 'Cantidades anteriores';

      const current = document.createElement('option');
      current.value = String(currentQty);
      current.textContent = String(currentQty);
      current.selected = true;

      previous.appendChild(current);
      fragment.appendChild(previous);
    }

    select.replaceChildren(fragment);
    select.disabled = !!input.disabled;
    select.value = String(currentQty);
    select.dataset.gowinQtySignature = signature;
  };

  const closeCustomInput = (wrapper, select, customInput) => {
    if (customInput?.isConnected) customInput.remove();
    wrapper?.classList.remove('gowin-cart-qty-inline--custom');
    if (select) {
      select.hidden = false;
      select.removeAttribute('aria-hidden');
      select.tabIndex = 0;
    }
  };

  const openCustomInput = (wrapper, select, input, removeButton, shouldFocus = true) => {
    if (!wrapper || !select || !input || wrapper.querySelector('.gowin-cart-qty-inline__custom')) return;

    const currentQty = getCurrentQty(input);
    const explicitMax = getExplicitMax(input);
    const customInput = document.createElement('input');
    customInput.className = 'gowin-cart-qty-inline__select gowin-cart-qty-inline__custom';
    customInput.style.setProperty('background-image', 'none', 'important');
    customInput.style.setProperty('padding', '0 .8rem', 'important');
    customInput.style.setProperty('text-align', 'center', 'important');
    customInput.type = 'number';
    customInput.inputMode = 'numeric';
    customInput.pattern = '[0-9]*';
    customInput.min = '0';
    customInput.step = input.getAttribute('step') || '1';
    customInput.value = String(currentQty > DIRECT_QTY_MAX ? currentQty : DIRECT_QTY_MAX + 1);
    customInput.setAttribute('aria-label', 'Ingresar cantidad');
    customInput.setAttribute('enterkeyhint', 'done');
    if (explicitMax !== null) customInput.max = String(explicitMax);
    if (input.disabled) customInput.disabled = true;

    select.hidden = true;
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    wrapper.classList.add('gowin-cart-qty-inline--custom');
    wrapper.appendChild(customInput);

    let committed = false;

    const commit = () => {
      if (committed || !customInput.isConnected) return;
      committed = true;

      const nextQty = parseInt(customInput.value || '', 10);
      if (!Number.isFinite(nextQty)) {
        closeCustomInput(wrapper, select, customInput);
        populateSelect(select, input);
        return;
      }

      if (nextQty <= 0) {
        removeButton?.click();
        return;
      }

      closeCustomInput(wrapper, select, customInput);
      updateRealQuantity(input, nextQty);

      window.setTimeout(() => {
        if (select.isConnected && input.isConnected) {
          populateSelect(select, input);
        }
      }, 900);
    };

    customInput.addEventListener('change', commit);
    customInput.addEventListener('blur', commit);
    customInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        customInput.blur();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        committed = true;
        closeCustomInput(wrapper, select, customInput);
        populateSelect(select, input);
        select.focus();
      }
    });

    if (shouldFocus) {
      requestAnimationFrame(() => {
        customInput.focus({ preventScroll: true });
        customInput.select();
      });
    }
  };

  const makeSelect = (row, input, removeButton) => {
    const wrapper = document.createElement('span');
    wrapper.className = 'gowin-cart-qty-inline';

    const select = document.createElement('select');
    select.className = 'gowin-cart-qty-inline__select';
    select.setAttribute(
      'aria-label',
      `Cantidad de ${row.querySelector('.cart-item__name')?.textContent?.trim() || 'producto'}`
    );

    select.addEventListener('change', (event) => {
      event.stopPropagation();

      if (select.value === CUSTOM_VALUE) {
        openCustomInput(wrapper, select, input, removeButton);
        return;
      }

      const nextQty = parseInt(select.value || '1', 10);
      if (nextQty === 0) {
        removeButton?.click();
        return;
      }

      updateRealQuantity(input, nextQty);

      window.setTimeout(() => {
        if (select.isConnected && input.isConnected) populateSelect(select, input);
      }, 900);
    });

    wrapper.appendChild(select);
    return { wrapper, select };
  };

  // Protección temporal mientras el Liquid histórico aún usa item.index.
  // No interviene en scroll ni recomendaciones.
  const repairRowIndex = (row, index) => {
    if (!row || !Number.isInteger(index) || index < 1) return;

    row.id = `CartDrawer-Item-${index}`;

    const input = row.querySelector('.cart-item__quantity .quantity__input');
    if (input) {
      input.id = `Drawer-quantity-${index}`;
      input.dataset.index = String(index);
    }

    const removeWrapper = row.querySelector('cart-remove-button');
    if (removeWrapper) {
      removeWrapper.id = `CartDrawer-Remove-${index}`;
      removeWrapper.dataset.index = String(index);
    }

    const error = row.querySelector('.cart-item__error');
    if (error) error.id = `CartDrawer-LineItemError-${index}`;
  };

  const enhanceRow = (row) => {
    const price = row.querySelector('.gowin-cart-price');
    const quantityCell = row.querySelector('.cart-item__quantity');
    const input = quantityCell?.querySelector('.quantity__input');
    const removeButton = quantityCell?.querySelector('.cart-remove-button');
    if (!price || !quantityCell || !input) return;

    let topline = price.querySelector(':scope > .gowin-cart-price__topline');
    if (!topline) {
      topline = document.createElement('div');
      topline.className = 'gowin-cart-price__topline';
      price.insertBefore(topline, price.firstChild);

      const values = price.querySelector(':scope > .gowin-cart-price__values');
      const regularCurrent = price.querySelector(':scope > .gowin-cart-price__current');
      if (values) topline.appendChild(values);
      else if (regularCurrent) topline.appendChild(regularCurrent);
    }

    let qtyWrapper = topline.querySelector('.gowin-cart-qty-inline');
    let select = qtyWrapper?.querySelector('select.gowin-cart-qty-inline__select');

    if (!qtyWrapper || !select) {
      const built = makeSelect(row, input, removeButton);
      qtyWrapper = built.wrapper;
      select = built.select;
      topline.appendChild(qtyWrapper);
    }

    populateSelect(select, input);
    quantityCell.classList.add('gowin-cart-quantity-cell--v3');
  };

  const enhance = () => {
    scheduled = false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('.cart-items .cart-item').forEach((row, position) => {
      repairRowIndex(row, position + 1);
      enhanceRow(row);
    });
  };

  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  const resetDrawerToTop = (drawer) => {
    const scrollArea = drawer.querySelector('cart-drawer-items');
    if (!scrollArea) return;
    requestAnimationFrame(() => {
      scrollArea.scrollTop = 0;
    });
  };

  const observeDrawer = (drawer) => {
    if (drawer === observedDrawer) return;

    observer?.disconnect();
    observer = new MutationObserver((mutations) => {
      scheduleEnhance();

      const drawerClassChanged = mutations.some(
        (mutation) =>
          mutation.target === drawer &&
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
      );

      if (drawerClassChanged) {
        const isOpen = drawer.classList.contains('active');
        if (isOpen && !wasOpen) resetDrawerToTop(drawer);
        wasOpen = isOpen;
      }
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    observedDrawer = drawer;
    wasOpen = drawer.classList.contains('active');
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    observeDrawer(drawer);
    scheduleEnhance();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('gowin:cart-patched', enhance);
  document.addEventListener('cart:updated', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
